import { MASSIVE_M } from "./types.js";

export const MUTATION_SET_PROCESS_STATE = `${MASSIVE_M}MUTATION_SET_PROCESS_STATE`;
export const MUTATION_SET_SELECTED_FILE = `${MASSIVE_M}MUTATION_SET_SELECTED_FILE`;
export const MUTATION_SET_UPLOAD_PROGRESS = `${MASSIVE_M}MUTATION_SET_UPLOAD_PROGRESS`;
export const MUTATION_SET_VALIDATION_RESULT = `${MASSIVE_M}MUTATION_SET_VALIDATION_RESULT`;
export const MUTATION_SET_PROCESS_RESULT = `${MASSIVE_M}MUTATION_SET_PROCESS_RESULT`;
export const MUTATION_SET_UPLOAD_DRAWER_OPEN = `${MASSIVE_M}MUTATION_SET_UPLOAD_DRAWER_OPEN`;
export const MUTATION_SET_DELETE_DRAWER_OPEN = `${MASSIVE_M}MUTATION_SET_DELETE_DRAWER_OPEN`;
export const MUTATION_SET_CURRENT_STEP = `${MASSIVE_M}MUTATION_SET_CURRENT_STEP`;
export const MUTATION_SET_ERRORS = `${MASSIVE_M}MUTATION_SET_ERRORS`;
export const MUTATION_RESET_PROCESS = `${MASSIVE_M}MUTATION_RESET_PROCESS`;
